import { useMutation } from '@tanstack/react-query';
import { updateCity } from '@/api/city';
import { UpdateCityData ,ReturnUpdateDelete} from "@/types";
import { PostParam } from "@/types/index";

export function useUpdateCity(props?: PostParam) {
  const { onSuccess, onError } = props || {};

  return useMutation<ReturnUpdateDelete, Error, UpdateCityData>({
    mutationFn: updateCity,
    onSuccess,
    onError
  });
}
